import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15ad4f4b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
import { useStore } from '@/store';
import { ArrowLeft } from '@element-plus/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuFold',
  setup(__props) {
    const store = useStore();
    const changeSiderType = () => {
      store.commit('app/setSiderType');
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "mobile-menu-close",
        text: "",
        onClick: changeSiderType
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
          _: 1
        }), _createTextVNode(" 收起菜单 ")]),
        _: 1
      })]);
    };
  }
});